import gameData from "../../gameData";
import { toggleBack } from "./nextBackHandler";
import { finalScreen } from "./finalScreen";
import { textIn } from "../inGame/tweenTimelines";
import sKey from "../../SoundAssetKeys";

export function eatDonut(scene)
{
    /*  sets up click to eat donut screen. Also contains the specific shapes that
        are drawn to the render texture for each shape to mask them for the bites,
        along with dev tools to edit them if needed
    */
    const circleS = 55;
    const donutType = gameData.makeData.selected.shape.toLocaleLowerCase();
    let arr = eval(`${donutType}Bite`)();
    let count = 0;
    const rendCircle = new Phaser.GameObjects.Ellipse(scene,100,100,circleS*2,circleS*2,0x000000,1);
    const tinyCircles = [
        new Phaser.GameObjects.Ellipse(scene,100,100,3,3,0x000000,1),
        new Phaser.GameObjects.Ellipse(scene,100,100,4.2,4.2,0x000000,1),
        new Phaser.GameObjects.Ellipse(scene,100,100,2,2,0x000000,1),
        new Phaser.GameObjects.Ellipse(scene,100,100,6,6,0x000000,1)
    ];

    /**********Tools */
    // let lastPoint = {x:0,y:0};
    // let circleDots = [];
    // let circleOutput = "";

    // scene.input.keyboard.on('keydown-SPACE', ()=>{
    //     scene.rend.erase(rendCircle,lastPoint.x,lastPoint.y);
    //     circleDots.pop();
    // })
    /**********End Tools */

    scene.back.setInteractive();
    scene.back.removeListener('pointerdown'); //used to avoid doubling up on restart - or when navigating back to screen
    scene.back.on('pointerdown',(point)=>{
        /****************dev tools */
        // circleDots.push("biteArr.push(new Phaser.Geom.Circle(" + Math.round(point.x) + "," +Math.round(point.y)+","+circleS+"));");
        // circleOutput = "";
        // for(let each in circleDots)
        // {
        //     circleOutput += circleDots[each];
        // }
        // console.log(circleOutput);
        // scene.rend.draw(rendCircle,point.x, point.y);
        // lastPoint.x = point.x;
        // lastPoint.y = point.y;
        /**********end tools */
        if(count < arr.length -1)
        {
            scene.custSound.playSoundCustom(sKey._eat_donut);
            circumPoint(arr[count],rendCircle,scene,tinyCircles);
            scene.part.emitParticleAt(arr[count].x,arr[count].y,40);
            count++;    
        }
        else
        {
            circumPoint(arr[count],rendCircle,scene,tinyCircles);
            scene.part.emitParticleAt(arr[count].x,arr[count].y,40);
            count++;

            scene.back.disableInteractive();
            scene.nextBut.disableInteractive();
            scene.backBut.disableInteractive();
            textIn(scene,"");

            toggleBack(scene);

            finalScreen(scene);
        }
    });
}

export function cleanUpEat(scene)
{
    scene.rend.clear();
    scene.back.disableInteractive();
    scene.back.removeListener('pointerdown');
}

/** creates the random sizes for each of the bite circles created
 * 
 * @param {*} cir - the geom circle
 * @param {*} rendCircle - the circle that will be drawn to the rendertexture
 * @param {*} scene 
 * @param {*} tinyCircles - array of circle sizes
 */
function circumPoint(cir,rendCircle,scene,tinyCircles)
{

    scene.rend.fillCircle(cir.x, cir.y, rendCircle.width/2);
    for(let x = 0; x < 50; x++)
    {
        let xP = Math.floor(Math.random()*2);
        let yP = Math.floor(Math.random()*2);
        let cP = Math.floor(Math.random()*tinyCircles.length);

        if(Math.round(Math.random())) xP *= -1;
        if(Math.round(Math.random())) yP *= -1;

        let point = Phaser.Geom.Circle.CircumferencePoint(cir,x);

        scene.rend.fillCircle(point.x,point.y,tinyCircles[cP].width/2);
    }
    //scene.rend.endDraw();
}

function triangleBite()
{
    const biteArr = [];
    biteArr.push(new Phaser.Geom.Circle(598,488,55));
    biteArr.push(new Phaser.Geom.Circle(554,408,55));
    biteArr.push(new Phaser.Geom.Circle(519,332,55));
    biteArr.push(new Phaser.Geom.Circle(466,383,55));
    biteArr.push(new Phaser.Geom.Circle(513,473,55));
    biteArr.push(new Phaser.Geom.Circle(433,477,55));
    return biteArr;
}

function heartBite()
{
    const biteArr = [];
    biteArr.push(new Phaser.Geom.Circle(580,319,55));
    biteArr.push(new Phaser.Geom.Circle(605,394,55));
    biteArr.push(new Phaser.Geom.Circle(553,469,55));
    biteArr.push(new Phaser.Geom.Circle(532,397,55));
    biteArr.push(new Phaser.Geom.Circle(494,336,55));
    biteArr.push(new Phaser.Geom.Circle(422,322,55));
    biteArr.push(new Phaser.Geom.Circle(437,398,55));
    biteArr.push(new Phaser.Geom.Circle(482,466,55));
    return biteArr
}

function starBite()
{
    const biteArr = [];
    biteArr.push(new Phaser.Geom.Circle(614,380,55));
    biteArr.push(new Phaser.Geom.Circle(577,432,55));
    biteArr.push(new Phaser.Geom.Circle(571,501,55));
    biteArr.push(new Phaser.Geom.Circle(524,301,55));
    biteArr.push(new Phaser.Geom.Circle(540,363,55));
    biteArr.push(new Phaser.Geom.Circle(462,349,55));
    biteArr.push(new Phaser.Geom.Circle(409,368,55));
    biteArr.push(new Phaser.Geom.Circle(452,404,55));
    biteArr.push(new Phaser.Geom.Circle(531,428,55));
    biteArr.push(new Phaser.Geom.Circle(467,487,55));
    return biteArr
}

function squareBite()
{
    const biteArr = [];
    biteArr.push(new Phaser.Geom.Circle(437,323,55));
    biteArr.push(new Phaser.Geom.Circle(438,404,55));
    biteArr.push(new Phaser.Geom.Circle(509,326,55));
    biteArr.push(new Phaser.Geom.Circle(440,487,55));
    biteArr.push(new Phaser.Geom.Circle(514,474,55));
    biteArr.push(new Phaser.Geom.Circle(525,397,55));
    biteArr.push(new Phaser.Geom.Circle(584,331,55));
    biteArr.push(new Phaser.Geom.Circle(586,414,55));
    biteArr.push(new Phaser.Geom.Circle(590,484,55));
    return biteArr
}

function roundBite()
{
    const biteArr = [];
    biteArr.push(new Phaser.Geom.Circle(578,471,55));
    biteArr.push(new Phaser.Geom.Circle(602,396,55));
    biteArr.push(new Phaser.Geom.Circle(503,499,55));
    biteArr.push(new Phaser.Geom.Circle(525,419,55));
    biteArr.push(new Phaser.Geom.Circle(568,341,55));
    biteArr.push(new Phaser.Geom.Circle(444,465,55));
    biteArr.push(new Phaser.Geom.Circle(431,393,55));
    biteArr.push(new Phaser.Geom.Circle(496,360,55));
    biteArr.push(new Phaser.Geom.Circle(505,301,55));
    biteArr.push(new Phaser.Geom.Circle(444,324,55));
    return biteArr
}

function ringBite()
{
    const biteArr = [];
    biteArr.push(new Phaser.Geom.Circle(580,341,55));
    biteArr.push(new Phaser.Geom.Circle(583,407,55));
    biteArr.push(new Phaser.Geom.Circle(569,472,55));
    biteArr.push(new Phaser.Geom.Circle(528,469,55));
    biteArr.push(new Phaser.Geom.Circle(518,329,55));
    biteArr.push(new Phaser.Geom.Circle(466,494,55));
    biteArr.push(new Phaser.Geom.Circle(457,329,55));
    biteArr.push(new Phaser.Geom.Circle(440,438,55));
    biteArr.push(new Phaser.Geom.Circle(440,381,55));
    return biteArr
}